import React, {useState, useEffect} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter, Button, CustomInput} from 'reactstrap';
import {toast} from 'react-toastify';
import {changeUserPermissions} from 'utils/api';
import SpinnerButton from 'components/SpinnerButton';
//import './style.scss';

const PermissionsModal = ({user, handleErrors, isOpen, toggle, refreshList}) => {
    const [submitting, setSubmitting] = useState(false);
    const [permissions, setPermissions] = useState([]);

    useEffect(() => {
        setPermissions([...user.roles]);
    }, [user]);

    const submitPermissions = async() => {
        try {
            setSubmitting(true);
            let renamedPermissions = [];
            if(permissions.includes('ROLE_FETCHES')) {
                renamedPermissions.push('fetches');
                permissions.includes('ROLE_VS') && renamedPermissions.push('vs');
                permissions.includes('ROLE_SOCIAL') && renamedPermissions.push('social');
            }
            if(permissions.includes('ROLE_ENTITY')) {
                renamedPermissions.push('entity');
                permissions.includes('ROLE_SEARCH') && renamedPermissions.push('search');
            }
            permissions.includes('ROLE_READER') && renamedPermissions.push('reader');
            const params = {
                roles: renamedPermissions,
            };
            await changeUserPermissions(user.id, params);
            refreshList(true);
            // this.props.updatePermissionsForUser(this.state.permissions, this.props.user.id);
            toast.success('Permissions successfully updated');
            setSubmitting(false);
            toggle();
        } catch(err) {
            console.log(err);
            handleErrors(err);
            setSubmitting(false);
        }
    };

    // toggle(item);
    // {
    //     let {permissions} = this.state;
    //     if(permissions.includes(item)) {
    //         permissions.splice(permissions.indexOf(item), 1);
    //     } else {
    //         permissions.push(item);
    //     }
    //     this.setState({permissions});
    // }

    const handlePermissionSelect = (e, disableOtherFetchesOptions) => {
        let tempPermissions = [...permissions];
        let role = e.target.name;
        if(tempPermissions.includes(role)) {
            tempPermissions.splice(tempPermissions.indexOf(role), 1);
        } else {
            tempPermissions.push(role);
        }
        setPermissions(tempPermissions);
    };

    const handleFetchesSelect = () => {
        let tempPermissions = [...permissions];
        if(tempPermissions.includes('ROLE_FETCHES')) {
            tempPermissions.includes('ROLE_SOCIAL') && tempPermissions.splice(tempPermissions.indexOf('ROLE_SOCIAL'), 1);
            tempPermissions.includes('ROLE_VS') && tempPermissions.splice(tempPermissions.indexOf('ROLE_VS'), 1);
            tempPermissions.splice(tempPermissions.indexOf('ROLE_FETCHES'), 1);
        } else {
            tempPermissions.push('ROLE_FETCHES');
        }
        setPermissions(tempPermissions);
    }

    const handleEntitySelect = () => {
        let tempPermissions = [...permissions];
        if(tempPermissions.includes('ROLE_ENTITY')) {
            tempPermissions.includes('ROLE_SEARCH') && tempPermissions.splice(tempPermissions.indexOf('ROLE_SEARCH'), 1);
            tempPermissions.splice(tempPermissions.indexOf('ROLE_ENTITY'), 1);
        } else {
            tempPermissions.push('ROLE_ENTITY');
        }
        setPermissions(tempPermissions);
    }


    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" keyboard={false} centered={true}>
            <ModalHeader toggle={toggle}>
                <strong>Edit Permissions</strong>
                <div style={{
                    color: 'gray',
                    fontSize: '14px',
                    fontWeight: 'bold',
                }}>{user.name}{user.name && user.email ? ' -' +
                    ' ' : ''}{user.email}</div>
            </ModalHeader>
            <ModalBody>
                <div className="d-flex pb-2">
                    <CustomInput
                        id={user.id + 'reader'}
                        type="checkbox"
                        name="ROLE_READER"
                        checked={permissions.includes('ROLE_READER')}
                        onChange={(e) => handlePermissionSelect(e)}
                    />
                    <div>Ticker</div>
                </div>
                <div className="d-flex pb-2">
                    <CustomInput
                        id={user.id + 'entity'}
                        type="checkbox"
                        name="ROLE_ENTITY"
                        checked={permissions.includes('ROLE_ENTITY')}
                        onChange={(e) => handleEntitySelect(e)}
                    />
                    <div>Entities</div>
                </div>
                <div className="d-flex flex-column ml-4">
                    <div className="d-flex pb-2">
                        <CustomInput
                            id={user.id + 'search'}
                            type="checkbox"
                            name="ROLE_SEARCH"
                            disabled={!permissions.includes('ROLE_ENTITY')}
                            checked={permissions.includes('ROLE_SEARCH')}
                            onChange={(e) => handlePermissionSelect(e)}
                        />
                        <div style={{color: !permissions.includes('ROLE_ENTITY') ? 'gray' : 'inherit'}}>Saved Searches</div>
                    </div>
                </div>
                <div className="d-flex pb-2">
                    <CustomInput
                        id={user.id + 'fetches'}
                        type="checkbox"
                        name="ROLE_FETCHES"
                        checked={permissions.includes('ROLE_FETCHES')}
                        onChange={(e) => handleFetchesSelect(e)}
                    />
                    <div>Fetches</div>
                </div>
                <div className="d-flex flex-column ml-4">
                    <div className="d-flex pb-2">
                        <CustomInput
                            id={user.id + 'vs'}
                            type="checkbox"
                            name="ROLE_VS"
                            checked={permissions.includes('ROLE_VS')}
                            disabled={!permissions.includes('ROLE_FETCHES')}
                            onChange={(e) => handlePermissionSelect(e)}
                        />
                        <div style={{color: !permissions.includes('ROLE_FETCHES') ? 'gray' : 'inherit'}}>Visual
                            Selector
                        </div>
                    </div>
                    <div className="d-flex">
                        <CustomInput
                            id={user.id + 'social'}
                            type="checkbox"
                            name="ROLE_SOCIAL"
                            checked={permissions.includes('ROLE_SOCIAL')}
                            disabled={!permissions.includes('ROLE_FETCHES')}
                            onChange={(e) => handlePermissionSelect(e)}
                        />
                        <div style={{color: !permissions.includes('ROLE_FETCHES') ? 'gray' : 'inherit'}}>Social Media
                        </div>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter className="select-fetches-modal-footer">
                <Button style={{color: 'white'}} onClick={toggle}>
                    Cancel
                </Button>
                <SpinnerButton
                    title="Save Changes"
                    submitting={submitting}
                    minWidth="123.22px"
                    onClick={submitPermissions}
                />
            </ModalFooter>
        </Modal>
    );
};

export default PermissionsModal;